<div class="flex flex-col gap-2 p-3" [hsLayer]="'one'">
  <div class="header">{{ title }}</div>
  <hs-divider></hs-divider>
  <div [innerHTML]="text"></div>

  <div class="flex flex-row w-full justify-end gap-2 p-2">
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="filled"
      (click)="dialogRef.close()"
    >
      Ok
    </button>
  </div>
</div>
